// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-square {
  height: 38px;
  text-align: center;
  padding: var(--ion-margin);
  transition: border-top-color 0.2s linear, border-bottom-color 0.2s linear, border-left-color 0.2s linear, border-right-color 0.2s linear, color 0.2s linear, background-color 0.2s linear;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 8px;
  color: #fff;
  padding: 10px;
  border: 1px solid var(--accent-color);
}
.slot-square.selected {
  color: white;
  background: var(--accent-color) !important;
}

.slot-col {
  max-height: 168px;
  overflow: auto;
}

.header-color {
  color: #B0B0B0;
  line-height: 17px;
  margin: 5px;
  font-size: 14px;
  font-family: OpenSans, sans-serif;
  text-align: center;
}

.no-padding {
  padding: 0px !important;
}

.smaller {
  font-size: 11px;
  padding: 16px 0px;
  text-transform: lowercase;
}

ion-col, ion-row {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-date-formcontrol/select-date-formcontrol.component.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,yLACQ;EAMR,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;AAPF;AAQE;EACE,YAAA;EACA,0CAAA;AANJ;;AASA;EACE,iBAAA;EACA,cAAA;AANF;;AASA;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AANF;;AAQA;EACE,uBAAA;AALF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,qBAAA;AAJF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.slot-square {\n  height: 38px;\n  text-align: center;\n  padding: var(--ion-margin);\n  transition:\n          border-top-color 0.2s linear,\n          border-bottom-color 0.2s linear,\n          border-left-color 0.2s linear,\n          border-right-color 0.2s linear,\n          color 0.2s linear,\n          background-color 0.2s linear;\n  margin-bottom: 4px;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #fff;\n  padding: 10px;\n  border: 1px solid var(--accent-color);\n  &.selected {\n    color: white;\n    background: var(--accent-color) !important;\n  }\n}\n.slot-col {\n  max-height: 168px;\n  overflow: auto;\n}\n\n.header-color{\n  color: #B0B0B0;\n  line-height: 17px;\n  margin: 5px;\n  font-size: 14px;\n  font-family: OpenSans, sans-serif;\n  text-align: center;\n}\n.no-padding{\n  padding: 0px !important;\n}\n.smaller{\n  font-size: 11px;\n  padding: 16px 0px;\n  text-transform: lowercase;\n}\n\nion-col, ion-row {\n  padding: 0!important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
